import CommonFormControl from "@/components/utils/CommonFormControl";
import { FormControlProps, FormLabel, TextField } from "@mui/material";
import { Control, Controller, FieldValues, UseFormRegister } from "react-hook-form";
import { useTranslation } from "react-i18next";

function ControlledEmailTextField({
  containerProps,
  control,
  register,
  defaultValue,
}: {
  containerProps?: FormControlProps;
  control: Control;
  register: UseFormRegister<FieldValues>;
  defaultValue?: string;
}) {
  const { t } = useTranslation("common");

  return (
    <CommonFormControl {...containerProps}>
      <FormLabel>{t("form.email")}</FormLabel>
      <Controller
        control={control}
        name={"email"}
        defaultValue={defaultValue || ""}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <TextField
            {...register("email", {
              required: true,
              pattern: {
                value:
                  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                message: t("form.emailInvalid"),
              },
            })}
            value={value}
            onChange={onChange}
            error={!!error}
            placeholder={t("form.emailPlaceholder")}
          />
        )}
      />
    </CommonFormControl>
  );
}

export default ControlledEmailTextField;
